import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sc-progress-bar',
  templateUrl: './progress-bar.html',
  styleUrls: ['progress-bar.css']
})
export class ProgressBarComponent implements OnInit {
  @Input() public color = 'primary';

  public ngOnInit(): void {
    // Nothing to do for now
  }
}
